module.exports = __webpack_public_path__ + "img/cms-hover.6ef80b9b.png";